import { AvailablePaymentMethodsContextProvider, ProfileNavigationContextProvider } from './contexts'

import { FC } from 'react'
import { Outlet } from 'react-router-dom'
import { PageTransition } from 'utils/animations'
import { ProfileController } from './Profile.controller'
import { useAuth0 } from 'utils/auth'

/** Parent wrapper component for profile routes - provides contexts and renders Outlet for nested routes */
export const Profile: FC = () => {
  const { roles } = useAuth0()

  // Legacy profile for non-clients or when feature flag is off
  if (!roles.isClient) {
    return (
      <PageTransition>
        <AvailablePaymentMethodsContextProvider>
          <ProfileController />
        </AvailablePaymentMethodsContextProvider>
      </PageTransition>
    )
  }

  // New profile with tabs for clients
  return (
    <AvailablePaymentMethodsContextProvider>
      <ProfileNavigationContextProvider>
        <Outlet />
      </ProfileNavigationContextProvider>
    </AvailablePaymentMethodsContextProvider>
  )
}
